import React, { useCallback } from 'react';
import { Select, MenuItem, ListSubheader, FormControl } from '@material-ui/core';

type SelectFieldProps = {
    value: string | number;
    onChange: (value: string | number) => void;
    options: {
        label: string | React.ReactNode;
        options: { value: string | number; label: string | React.ReactNode }[];
    }[];
};

const SelectFieldGrouped: React.FC<SelectFieldProps> = ({ value, onChange, options }) => {
    const handleOnChange = useCallback(
        (event: React.ChangeEvent<{ value: unknown }>) => {
            onChange(event.target.value as string | number);
        },
        [onChange]
    );

    return (
        <FormControl fullWidth style={{ margin: '10px 0' }}>
            <Select
                value={value}
                onChange={handleOnChange}
                displayEmpty
                renderValue={(selected) => {
                    if (!selected) {
                        return 'Select...';
                    }
                    for (const group of options) {
                        for (const option of group.options) {
                            if (option.value === selected) {
                                return option.label;
                            }
                        }
                    }
                    return selected;
                }}
            >
                {options.map((group) => [
                    <ListSubheader
                        key={`group-${group.label}`}
                        component="div"
                        color="primary"
                        style={{ textTransform: 'uppercase' }}
                    >
                        {group.label}
                    </ListSubheader>,
                    ...group.options.map((option) => (
                        <MenuItem key={option.value.toString()} value={option.value}>
                            {option.label}
                        </MenuItem>
                    )),
                ])}
            </Select>
        </FormControl>
    );
};

export default SelectFieldGrouped;
